import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setRoadmapData } from "../../../../../Redux/slices/mngrSlice";
import { post_category_roadmap } from "http/components/Roadmap";

export default function AddCategoryRoadmapData() {
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    title: {
      label: "Title",
      type: "text",
      multiLine: false,
      placeholder: "Enter title",
      value: "",
      validation: false,
    },
    description: {
      label: "Description",
      type: "text",
      multiLine: true,
      placeholder: "Description",
      value: "",
      validation: false,
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setControls({ title: { value: "", validation: false } });
    setControls({ description: { value: "", validation: false } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onSubmit = async () => {
    const { title, description } = controls;
    if (title.validation && description.validation) {
      dispatch(HandleLoading(true));
      const response = await post_category_roadmap({
        title: title.value,
        description: description.value,
      });
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setRoadmapData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid2 size={{ xs: 12 }} key={key + index}>
            {controls[key].type === "text" && (
              <Inputer
                id={key}
                setValue={setValue.bind(this)}
                value={controls[key].value}
                label={controls[key].label}
                placeholder={controls[key].placeholder}
                type={controls[key].type}
                multiLine={controls[key].multiLine}
              />
            )}
          </Grid2>
        );
      })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
